import { IRequirementStructuralUnitType } from '../../../APIPackage/RequirementsNpaModule/interfaces/IRequirementStructuralUnit';

export const requirementStructuralUnitTypes: IRequirementStructuralUnitType[] = [
  {
    id: 8,
    label: 'Раздел',
    value: 'SECTION',
  },
  {
    id: 7,
    label: 'Подраздел',
    value: 'SUBSECTION',
  },
  {
    id: 6,
    label: 'Глава',
    value: 'CHAPTER',
  },
  {
    id: 9,
    label: 'Параграф',
    value: 'PARAGRAPH',
  },
  {
    id: 5,
    label: 'Статья',
    value: 'ARTICLE',
  },
  {
    id: 4,
    label: 'Часть',
    value: 'PART',
  },
  {
    id: 2,
    label: 'Пункт',
    value: 'ITEM',
  },
  {
    id: 3,
    label: 'Подпункт',
    value: 'SUBITEM',
  },
  {
    id: 1,
    label: 'Абзац',
    value: 'INDENT',
  },
  {
    id: 10,
    label: 'Другое / прочее',
    value: 'OTHER',
  },
];
